import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {PaymentTransactionRequest} from "../models/paymentTransactionRequest";
import {PaymentTransactionResponse} from "../interface/paymentTransactionResponse";
import {WalletToWalletPaymentReceipt} from "../models/payment/walletToWalletPaymentReceipt";

@Injectable({
  providedIn: "root"
})
export class PaymentTransactionService {

  private readonly ENDPOINT_URL: string = `${environment.apiUrl}/payment-transactions`;

  constructor(private http: HttpClient) {
  }

  public create(request: PaymentTransactionRequest, isCommissionActive: boolean): Observable<PaymentTransactionResponse> {
    const url = `${this.ENDPOINT_URL}?isCommissionActive=${isCommissionActive}`;
    return this.http.post<PaymentTransactionResponse>(url, request);
  }

  public getReceiptByIssuerId(issuerId: string): Observable<WalletToWalletPaymentReceipt> {
    const body = {
      issuerId: issuerId
    }
    const url: string = `${this.ENDPOINT_URL}/receipt`;
    return this.http.post<WalletToWalletPaymentReceipt>(url, body);
  }
}
